var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.dataList.length > 0)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.dataList[0].data)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }